<section class="home-section home-container__hero yellow-background">
  <div class="home-container">
    <app-home-hero></app-home-hero>
  </div>
</section>
<section class="home-section">
  <div class="home-container">
    <app-home-purpose-section></app-home-purpose-section>
  </div>
</section>
<section class="home-section">
  <div class="home-container">
    <ng-template #homeProductCategories></ng-template>
  </div>
</section>
<section class="home-section">
  <div class="home-container">
    <ng-template #homeExpertiseSection></ng-template>
  </div>
</section>
<section class="home-section">
  <div class="home-container">
    <ng-template #homeArticlesSection></ng-template>
  </div>
</section>
